import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar3 } from "../src/components/Navbar3";
function App() {
  return (
    <div className="App">
      <Navbar3 />
    </div>
  );
}

export default App;
